"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PendingReconciliationDialog',
  data: function data() {
    return {
      dialogVisible: false,
      searchForm: {
        page: 1,
        limit: 20,
        merchantType: '',
        merchantId: '',
        maintainer: '',
        orderTimeStart: '2025-01-01 00:00:00',
        orderTimeEnd: '2025-01-01 23:59:59'
      },
      // 静态 mock 数据
      tableData: {
        total: 20,
        list: [{
          merchantName: '家家乐',
          merchantType: '获得供应商',
          maintainerName: '张三',
          reconciledCount: 200,
          remainingCount: 1000
        }, {
          merchantName: '联华',
          merchantType: '获得供应商',
          maintainerName: '李四',
          reconciledCount: 300,
          remainingCount: 2000
        }]
      }
    };
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
    }
  }
};